import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../../components/dynamicscreens/DynamicMainScreen";
import { TownJson } from "../../../DynamicFormsJson/MastersJSON/Town";
import { getTown } from "../../../Slice/town.slice";
import { TownColumns } from "../../../tableColumns/table-columns";
class TownTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { town, getTown } = this.props;
    return (
      <>
        <DynamicMainScreen
          formPath={TownJson.formPath}
          screenTitle={TownJson.screenTitle}
          fieldMeta={TownJson.fieldMeta}
          showPdfDownload={TownJson.showPdfDownload}
          showExcelDownload={false}
          changeExcelURL={"contry-data" + '?sort={"sortOrder": "ASC"}'}
          showExtension={false}
          pdfFileName={TownJson.pdfFileName}
          excelFileName={TownJson.excelFileName}
          showAddButton={TownJson.showAddButton}
          tableColumnsToFilter={TownJson.tableColumnsToFilter}
          tableColumns={TownColumns}
          tableData={town?.town}
          getTableData={getTown}
          apiBaseURL={TownJson.apiBaseURL}
          baseIdColumn={TownJson.baseIdColumn}
          isNote={true}
          isNoteValue={"Town"}
          showDeleteIcon={true}
          showViewButtonInTable={true}
          formPathView={TownJson.formPathView}
          isActiveURL={TownJson.isActiveURL}
        />
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  town: state.town,
});
const mapDispatchToProps = {
  getTown,
};
export default connect(mapStateToProps, mapDispatchToProps)(TownTable);
